// Comparison: Add To Cart runs the product's own purchase flow; an unchosen size scrolls back to the fit picker.
if (!customElements.get('bl-compare')) customElements.define('bl-compare', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', event => {
      if (!event.target.closest('[data-compare-add]')) return;
      const product = document.querySelector('bl-product');
      if (product?.purchase) product.purchase(); else document.getElementById('choose-fit')?.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
  }
});
